import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { NavigationMenu } from "./navigation/NavigationMenu";
import { useAuth } from "@/contexts/AuthContext";

export const Navigation = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { isAuthenticated, setUser, setToken, user } = useAuth();

    const handleLogout = () => {
        setUser(null);
        setToken(null);
        navigate("/");
    };

    return (
        <nav className="bg-white shadow-lg fixed w-full z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-16">
                    <div className="flex-shrink-0 flex items-center">
                        <Link to="/" className="text-2xl font-bold text-primary flex items-center">
                            (<img src="/favicon-32x32.png" alt="Dietopia" className="w-6 h-6 block" />) Dietopia
                        </Link>
                    </div>

                    {/* Desktop Menu */}
                    <div className="hidden md:flex">
                        <NavigationMenu user={user} isAuthenticated={isAuthenticated} handleLogout={handleLogout} layout="horizontal" />
                    </div>

                    {/* Mobile Menu Button */}
                    <div className="md:hidden flex items-center">
                        <button onClick={() => setIsOpen(!isOpen)} className="text-gray-700 hover:text-primary">
                            {isOpen ? <X size={24} /> : <Menu size={24} />}
                        </button>
                    </div>
                </div>

                {/* Mobile Menu */}
                {isOpen && (
                    <div className="md:hidden">
                        <NavigationMenu
                            user={user}
                            isAuthenticated={isAuthenticated}
                            handleLogout={handleLogout}
                            layout="vertical"
                            onClose={() => setIsOpen(false)}
                        />
                    </div>
                )}
            </div>
        </nav>
    );
};
